module.exports = __webpack_public_path__ + "static/media/bg_homepage_menu.b819deaf.png";